var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.551 40.9012C290.406 30.0458 307.946 30.0458 318.802 40.9012L475.806 197.905C486.661 208.761 486.661 226.301 475.806 237.156C464.95 248.012 447.41 248.012 436.555 237.156L418.462 219.064L334.563 316.946C344.867 351.659 342.23 389.867 325.241 423.783L324.015 426.236C320.028 434.27 312.423 439.79 303.653 441.2C294.883 442.611 285.868 439.728 279.551 433.412L83.2954 237.156C76.9784 230.839 74.0959 221.947 75.5065 213.054C76.9171 204.161 82.4981 196.617 90.471 192.692L92.9242 191.466C126.84 174.477 165.048 171.84 199.761 182.144L297.643 98.2445L279.551 80.1522C268.695 69.2969 268.695 51.7566 279.551 40.9012ZM142.172 335.284L181.423 374.535L122.546 433.412C111.691 444.267 77.9683 442.968 74.245 438.432C70.5218 433.896 72.44 405.016 83.2954 394.161L142.172 335.284Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinActive);
export default __webpack_public_path__ + "static/media/pinActive.a5b689d1c6955198a752ab1c4d8a312d.svg";
export { ForwardRef as ReactComponent };